import { items } from "@/api/items/useItemQuery";
import { KPI } from "@/api/kpi/useKPIQuery";
import { columnlist } from "@/constants/columnlist";
import { useModal } from "@/features/modal/ModalStackManager";
import { Header } from "@/features/standard/Header";
import { HeaderSubTitle } from "@/features/standard/SubTitle";
import { HeaderTitle } from "@/features/standard/Title";
import { ItemAutoComplete } from "@/features/ui/autoComplete/item/item-autoComplete";
import { Calendar, isCalendarDate } from "@/features/ui/Calendar";
import { GridTable } from "@/features/ui/PMS/GridTable";
import CustomTable from "@/features/ui/table/CustomTable";
import { DatetimeUtilMinute, getEndOfDate, getStartOfDate } from "@/utils/dateTimeUtil";
import timeUtil from "@/utils/timeUtil";
import { ActionIcon, Flex, Space, Text } from "@mantine/core";
import { ItemsGet200ResponseRowsInnerItemTypeEnum } from "@sizlcorp/sizl-api-document/dist/models";
import { IconCalendar } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

const KPILeadTime = Object.assign({}, {
    Header: Header,
    HeaderTitle: HeaderTitle,
    HeaderSubTitle: HeaderSubTitle,
    CustomTable: CustomTable,
})

export const KPILeadtimePage = () => {
    const today = dayjs().subtract(1, 'day').startOf('day').toDate();
    const oneWeekAgo = dayjs().subtract(7, 'day').startOf('day').toDate();

    const [content, setContent] = useState<any[]>([]);
    const [selectList, setSelectList] = useState<Set<number>>(new Set());
    const [item, setItem] = useState<string | null>('');
    const [stateDate, setStateDate] = useState<[Date | null, Date | null]>([oneWeekAgo, today]);
    const [averageLeadTime, setAverageLeadTime] = useState<string>('');
    const { openModal } = useModal();

    const { data } = useQuery({
        ...items.get({
            query: {
                $and: [
                    { code: item }
                ]
            }
        }),
        enabled: !!item
    })

    const { data: leadTimeData } = useQuery({
        ...KPI.leadTime({
            itemCode: item ?? '',
            scheduledAtFrom: getStartOfDate(stateDate[0]),
            scheduledAtTo: getEndOfDate(stateDate[1])
        }),
        enabled: !!item
    })

    useEffect(() => {
        if (leadTimeData?.data) {
            const transformedData = leadTimeData.data.map((leadTime: any) => ({
                productionPlanId: leadTime.productionPlanId,
                scheduledAt: timeUtil(leadTime.scheduledAt),
                itemCode: leadTime.itemCode,
                itemSpec: leadTime.itemSpec,
                workerName: leadTime.workerName,
                workEndTime: DatetimeUtilMinute(leadTime.workEndTime),
                workStartTime: DatetimeUtilMinute(leadTime.workStartTime),
                leadTime: leadTime.leadTime,
            }));

            // leadTime의 평균 계산
            const totalLeadTime = leadTimeData?.data?.reduce((sum: number, leadTime: any) => sum + parseFloat(leadTime.leadTime), 0) ?? 0;
            const averageLeadTime = (totalLeadTime / leadTimeData.data.length).toFixed(2);
            setAverageLeadTime(averageLeadTime);
            setContent(transformedData);
        } else {
            setContent([]);
        }
    }, [leadTimeData]);

    const itemData = data?.data?.rows && data?.data?.rows[0]

    const TableHeader = {
        machine: ['품목코드', '품명', '규격', '평균 제조리드타임 (시간)'],
    }

    const BodyData = {
        machine: [{ '품목코드': itemData?.code ?? '-', '품명': itemData?.name, '규격': itemData?.spec ?? '-', '평균 제조리드타임 (시간)': averageLeadTime === "NaN" ? '-' : averageLeadTime }],
    }

    return (
        <Flex gap="md" direction={'column'}>
            <KPILeadTime.Header>
                <KPILeadTime.HeaderTitle>제조리드타임(P)</KPILeadTime.HeaderTitle>
                <KPILeadTime.HeaderSubTitle>생산계획에 대해 작업시작부터 작업종료까지 걸리는 시간 (단위: 시간)</KPILeadTime.HeaderSubTitle>
            </KPILeadTime.Header>
            <Flex justify={'space-between'} align={'center'}>
                <Space miw={'22rem'} />
                <Flex align={'center'}>
                    <Flex align="center" gap="sm" onClick={() => {
                        openModal(<Calendar dates={stateDate} type="range" isExclude={true} />, null, '날짜 선택')
                            .then((value) => {
                                if (isCalendarDate(value)) {
                                    setStateDate(value);
                                }
                            });
                    }}>
                        <Text size="2rem" fw="bold" style={{ cursor: "pointer" }}>
                            {timeUtil(stateDate[0]?.toISOString() ?? '')} ~ {timeUtil(stateDate[1]?.toISOString() ?? '')}
                        </Text>
                        <ActionIcon>
                            <IconCalendar size="2rem" />
                        </ActionIcon>
                    </Flex>
                </Flex>
                <ItemAutoComplete
                    placeholder="품목을 선택해주세요"
                    w="22rem"
                    size="lg"
                    getItemType={[ItemsGet200ResponseRowsInnerItemTypeEnum.PRODUCT, ItemsGet200ResponseRowsInnerItemTypeEnum.SEMI_PRODUCT]}
                    onChange={(value) => setItem(value)}
                />
            </Flex>

            <KPILeadTime.CustomTable
                headers={TableHeader.machine}
                data={BodyData.machine}
            />
            <GridTable
                headerList={[
                    ...columnlist.leadTimeItemTable
                ]}
                row={content}
                setRow={setContent}
                selectList={selectList}
                //@ts-ignore
                setSelectList={setSelectList}
                width={'100%'}
                maxWidth={'100%'}
                height={750}
                resizable={true}
            // scrollEnd={(value) => {
            //     if(value){
            //         if(keyword !== undefined){
            //             if(searchPage.total_page > searchPage.current_page){
            //                 getPressDailyStatusSearchApi(keyword, searchPage.current_page+ 1)
            //             }
            //         }else{
            //             if(page.total_page > page.current_page){
            //                 getPressDailyStatusApi(page.current_page+ 1)
            //             }
            //         }
            //     }
            // }}
            />
        </Flex>
    )
}